import React, { useEffect, useState } from "react";
import MainContainer from "../../layout/MainContainer";
import FileDownloadIcon from "@mui/icons-material/FileDownload";
import {
  Button,
  Card,
  IconButton,
  Switch,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Tooltip,
} from "@mui/material";
import Box from "@mui/material/Box";
import ModeEditIcon from "@mui/icons-material/ModeEdit";
import DeleteIcon from "@mui/icons-material/Delete";
import VisibilityIcon from "@mui/icons-material/Visibility";
import SearchBar from "../../components/SearchBar";
import { useNavigate, useParams } from "react-router-dom";
import AddIcon from "@mui/icons-material/Add";

import SearchBar2 from "../../components/SearchBar2";
import { isValidInput } from "../../utils/validation";
import { errorToast, successToast } from "../../helpers/toast";

import Pagination from "../../components/Pagination";
import WarnModal from "../../components/WarnModal";
import moment from "moment";
import EditKeyModal from "../../components/EditWarnModal";
import Loader from "../../helpers/constants/Loader";
import {
  useLazyDeleteLocationQuery,
  useLazyGetAllLocationQuery,
} from "../../services/location";

const ManageLocation = () => {
  const navigate = useNavigate();

  const [rows1, setRows1] = useState<any>([]);
  const [searchTerm, setSearchTerm] = useState("");
  const [page, setPage] = useState(1);

  const [totalCount, setTotalCount] = useState<number>(0);
  const [limit, setLimit] = useState<number>(10);
  let totalPages = Math.ceil(totalCount / limit);

  const [deleteBoostById] = useLazyDeleteLocationQuery();
  const [BoostList] = useLazyGetAllLocationQuery();
  const [openEdit, setOpenEdit] = useState<boolean>(false);
  const [debouncedSearchTerm, setDebouncedSearchTerm] = useState("");
  const [open, setOpen] = useState(false);
  const [isLoading, setIsLoading] = useState<boolean>(false);
  const [selectedId, setSelectedId] = useState<number>(0);
  const onPageChange = (newPage: number) => {
    setPage(newPage);
    setRows1([]);
  };
  const fetchData = async (page: number, search: string) => {
    setIsLoading(true);
    try {
      const response = await BoostList({
        page: page,
        search: search,
        limit: limit,
      }).unwrap();
      if (response.statusCode === 200) {
        setRows1(response?.data?.location || []);
        setTotalCount(response?.data?.count);
      }
      setIsLoading(false);
    } catch (error) {
      setIsLoading(false);
      console.error(error);
    }
  };

  const handleDeleteBoost = async (userId: any) => {
    setIsLoading(true);
    try {
      const response = await deleteBoostById({ userId }).unwrap();
      if (response?.statusCode === 200) {
        successToast("Location deleted successfully");
        fetchData(page, searchTerm);
      }
      setIsLoading(false);
    } catch (error: any) {
      setIsLoading(false);
      console.error(error);
      errorToast(error?.message || error?.data?.message);
    }
  };

  const naviagteFun = () => {
    navigate(`/manage-location/edit/${selectedId}`);
  };

  useEffect(() => {
    fetchData(page, debouncedSearchTerm);
  }, [page, debouncedSearchTerm, limit]);

  return (
    <div>
      <div className="main_loyout">
        <Loader isLoad={isLoading} />
        <div className="dashboard">
          <h1 className="mn_hdng">Manage Locations</h1>
        </div>

        <Card className="cards">
          <Box className="cards_header">
            <SearchBar2
              value={searchTerm}
              searchTerm={searchTerm}
              onCross={() => setSearchTerm("")}
              setDebouncedSearchTerm={setDebouncedSearchTerm}
              onChange={(val: any) => {
                if (isValidInput(val.target.value)) {
                  setSearchTerm(val.target.value);
                  setTimeout(() => {
                    setPage(1);
                  }, 1000);
                }
              }}
            />

            <Box className="cards_header_right">
              {/* <Button className="btn btn_primary">
                <FileDownloadIcon /> Export CSV
              </Button> */}
              <Button
                className="btn btn_primary"
                onClick={() => {
                  navigate("/manage-location/add");
                }}
              >
                <AddIcon />
                Add Location
              </Button>
            </Box>
          </Box>
          <TableContainer className="table_container">
            <Table sx={{ minWidth: 650 }} aria-label="simple table">
              <TableHead>
                <TableRow>
                  <TableCell align="center">S.No</TableCell>

                  <TableCell>Location Name</TableCell>
                  <TableCell>Latitude</TableCell>
                  <TableCell>Longitude</TableCell>

                  <TableCell>Action</TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {rows1?.length ? (
                  rows1?.map((row: any, index: any) => (
                    <TableRow key={row._id}>
                      <TableCell align="center">
                        {(page - 1) * 10 + index + 1}
                      </TableCell>

                      <TableCell>{row?.name}</TableCell>
                      <TableCell> {row?.latitude}</TableCell>
                      <TableCell>{row?.longitude}</TableCell>

                      <TableCell>
                        <Box className="table_actions">
                          <Tooltip title="Edit details">
                            <IconButton
                              onClick={() => {
                                setOpenEdit(true);
                                setSelectedId(row?._id);
                              }}
                            >
                              <ModeEditIcon />
                            </IconButton>
                          </Tooltip>
                          <Tooltip title="Delete location">
                            <IconButton
                              onClick={() => {
                                setOpen(true);
                                setSelectedId(row?._id);
                              }}
                            >
                              <DeleteIcon />
                            </IconButton>
                          </Tooltip>
                        </Box>
                      </TableCell>
                    </TableRow>
                  ))
                ) : (
                  <TableCell colSpan={5} align="center">
                    No data Found
                  </TableCell>
                )}
              </TableBody>
            </Table>
          </TableContainer>
        </Card>
      </div>
      {rows1?.length > 0 ? (
        <Pagination
          setPage={setPage}
          module={rows1}
          page={page}
          onPageChange={onPageChange}
          totalPages={totalPages}
          limit={limit}
          setLimit={setLimit}
        />
      ) : (
        ""
      )}
      <WarnModal
        open={open}
        setOpen={setOpen}
        handleDelete={() => handleDeleteBoost(selectedId)}
        name="Location"
      />
      <EditKeyModal
        open={openEdit}
        setOpen={setOpenEdit}
        navigate={naviagteFun}
      />
    </div>
  );
};

export default ManageLocation;
